import { render } from "./KpsDdMembersView.vue?vue&type=template&id=a0e3bea4&scoped=true"
import script from "./KpsDdMembersView.vue?vue&type=script&lang=js"
export * from "./KpsDdMembersView.vue?vue&type=script&lang=js"

import "./KpsDdMembersView.vue?vue&type=style&index=0&id=a0e3bea4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0e3bea4"]])

export default __exports__